import { PaginationParams } from "@dune/types";

export const gfasQueryKeys = {
	all: ["gfas"] as const,
	lists: () => [...gfasQueryKeys.all, "lists"] as const,
	list: (search?: string) => [...gfasQueryKeys.lists(), search] as const,
	details: () => [...gfasQueryKeys.all, "details"] as const,
	detail: (id: string) => [...gfasQueryKeys.details(), id] as const,
	syndicInfo: (id: string) =>
		[...gfasQueryKeys.all, "syndic-info", id] as const,
	clients: () => [...gfasQueryKeys.all, "clients"] as const,
	clientSearch: (search: string) =>
		[...gfasQueryKeys.clients(), search] as const,
	syndics: () => [...gfasQueryKeys.all, "syndics"] as const,
	syndicSearch: (search: string) =>
		[...gfasQueryKeys.syndics(), search] as const,
	files: (id: string) => [...gfasQueryKeys.all, "files", id] as const,
	filesOnGFA: (id: string) =>
		[...gfasQueryKeys.files(id), "filesOnGFA"] as const,
	tasks: (gfaId: string) => [...gfasQueryKeys.all, "tasks", gfaId] as const,
	documents: (gfaId: number, pagination?: PaginationParams) =>
		[
			...gfasQueryKeys.all,
			"documents",
			gfaId,
			`${pagination?.page ?? 1}-${pagination?.limit ?? 10}-${pagination?.search ?? ""}-${pagination?.isReferenced ?? ""}`,
		] as const,
	communications: (
		gfaId: string,
		options?: {
			page?: number;
			limit?: number;
			sortBy?: string;
			sortOrder?: "asc" | "desc";
		},
	) => [...gfasQueryKeys.all, "communications", gfaId, options] as const,
	communicationsAll: (constructionSiteId: number | string) =>
		[...gfasQueryKeys.all, "communications", constructionSiteId] as const,
	unprocessedCommunicationsCount: (constructionSiteId: string) =>
		[
			...gfasQueryKeys.all,
			"communications",
			constructionSiteId,
			"unprocessed-count",
		] as const,
	binderAmendment: () => [...gfasQueryKeys.all, "binder-amendment"] as const,
};
